import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { createPayment, fetchPayment, getApplicationPayments, updatePayment } from '../../services/payment'

export const createPaymentAction = createAsyncThunk(
  'payments/create',
  async ({ application, description, is_full, paid, pay_date }, { rejectWithValue, dispatch }) => {
    try {
      const response = await createPayment({ data: { application, description, is_full, paid, pay_date } })
      dispatch(fetchApplicationPaymentsAction(application))
      return response.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const fetchPaymentByIdAction = createAsyncThunk('payment/load', async (id, { rejectWithValue }) => {
  try {
    const data = await fetchPayment(id)
    return data.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const updatePaymentAction = createAsyncThunk(
  'payment/update',
  async ({ id, description, is_full, paid, pay_date }, { rejectWithValue }) => {
    try {
      const response = await updatePayment(id, {
        data: { id, description, is_full, paid, pay_date },
      })
      return response.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const fetchApplicationPaymentsAction = createAsyncThunk(
  'payments/application/fetch',
  async (application, { rejectWithValue }) => {
    try {
      const { data } = await getApplicationPayments(application)
      return { application, data: data.results }
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    applicationPayments: {},
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
  extraReducers: {
    [fetchApplicationPaymentsAction.pending]: (state) => {
      state.isFetching = true
    },
    [fetchApplicationPaymentsAction.rejected]: (state, error) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = error?.payload.message
    },
    [fetchApplicationPaymentsAction.fulfilled]: (state, { payload: { application, data } }) => {
      state.applicationPayments = { ...state.applicationPayments, [application]: data }
      state.isFetching = false
      state.isSuccess = true
      return state
    },
  },
})

export const paymentsSelector = (state) => state.payments
